import { useTranslation } from "react-i18next"
import { Badge } from "@nexus/ui"
import {
  PersonasOnboardingAnalyzing,
  type PersonasOnboardingAnalyzingProps,
} from "../PersonasOnboardingAnalyzing/PersonasOnboardingAnalyzing"

/** Setup chrome + Figma analyzing card — used before empty library and onboarding review. */
export function PersonasOnboardingAnalyzingView(props: PersonasOnboardingAnalyzingProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4 p-4" data-testid="personas-onboarding-analyzing-view">
      <div className="flex flex-col gap-1">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-xl font-semibold tracking-tight text-foreground">
            {t("personas.title", "User Personas")}
          </h1>
          <Badge variant="status-delivered" dot={false} iconStart="plus">
            {t("personas.onboarding.badge", "Setup")}
          </Badge>
        </div>
        <p className="text-sm text-muted-foreground">
          {t("personas.onboarding.header.analyzingSubtitle", "Hang tight while Adge reads your creative library.")}
        </p>
      </div>

      <PersonasOnboardingAnalyzing {...props} />
    </div>
  )
}
